import script from "./ListarEntradas.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarEntradas.vue?vue&type=script&setup=true&lang=js"

import "./ListarEntradas.vue?vue&type=style&index=0&id=2cbef58e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cbef58e"]])

export default __exports__